<script setup lang="ts">
import { THEME_COLOR } from "~/constants";
import MainOval from "./MainOval.vue";

const color = useColorMode();
</script>

<template>
  <main class="baseMain">
    <MainOval v-if="color.value === THEME_COLOR.DARK" class="baseMain__oval" />

    <div class="baseMain__content">
      <slot />
    </div>
  </main>
</template>

<style lang="scss">
.baseMain {
  @apply relative h-full;

  .baseMain__content {
    @apply relative z-10 h-full;

    color: var(--base-text-color);
  }

  .baseMain__oval {
    @apply absolute top-0 left-0 w-full h-full z-0;

    color: var(--base-primary-color);
  }
}
</style>
